import React from "react";
import { Link } from "react-router-dom";

function Breadcrumb({
    items = [],
    separator = "/",
    className = "",
    navClassName = "",
    itemClassName = "",
    activeItemClassName = "",
    separatorClassName = "",
    ariaLabel = "Breadcrumb",
}) {
    if (!items.length) {
        return null;
    }

    return (
        <>
            <nav
                aria-label={ariaLabel}
                className={`fixed top-16 left-0 right-0 z-40 border-b border-white/10 bg-[#062a1a]/80 backdrop-blur-sm ${navClassName}`.trim()}
            >
                <div className="mx-auto w-full max-w-7xl px-4 md:px-10">
                    <ol className="flex items-center gap-2 py-2 text-xs font-medium tracking-wide">
                        {items.map((item, index) => {
                            const isLast = index === items.length - 1;
                            const isCurrent = item.isCurrent ?? isLast;

                            return (
                                <React.Fragment key={`${item.label}-${index}`}>
                                    <li>
                                        {item.to && !isCurrent ? (
                                            <Link
                                                to={item.to}
                                                className={`text-slate-400 hover:text-green-400 transition-colors ${itemClassName}`.trim()}
                                            >
                                                {item.label}
                                            </Link>
                                        ) : (
                                            <span
                                                aria-current={isCurrent ? "page" : undefined}
                                                className={`${isCurrent ? "text-white" : "text-slate-400"} ${isCurrent ? activeItemClassName : itemClassName}`.trim()}
                                            >
                                                {item.label}
                                            </span>
                                        )}
                                    </li>
                                    {!isLast && (
                                        <li className={`text-slate-600 ${separatorClassName}`.trim()} aria-hidden="true">
                                            {separator}
                                        </li>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </ol>
                </div>
            </nav>

            <div className={`h-8 ${className}`.trim()} aria-hidden="true" />
        </>
    );
}

export default Breadcrumb;
